<div class="d-flex flex-row justify-content-between align-items-center">

  <div class="d-flex flex-column">
    <nav class="breadcrumbs">
      <a [href]="homeRoute" class="back-button" *ngIf="showMainMenuButton">
        <i class="fas fa-angle-left"></i>
        Validaciones
      </a>
      <ng-container *ngIf="breadcrumbs && breadcrumbs.length > 0">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
          <a *ngIf="item.route" [href]="item.route">
            {{ item.label }}
          </a>

          <span *ngIf="!item.route">
            {{ item.label }}
          </span>

          <span *ngIf="!last"> / </span>
        </ng-container>
      </ng-container>
    </nav>
    <div>
      <!-- Fallback -->
      <h2 class="detail-title mb-0">{{ title }}</h2>

      <!-- Título -->
      <ng-content select="[header-title]"></ng-content>

      <!-- Fallback -->
      <h4 class="detail-subtitle mb-0">{{ subtitle }}</h4>

      <!-- Subtítulo -->
      <ng-content select="[header-subtitle]"></ng-content>
    </div>
  </div>

  <div>
    <ng-content select="[header-logo]"></ng-content>

    <img
      *ngIf="showLogo"
      width="160"
      src="./assets/images/logo-gl-tracker-blue-dark.svg"
      alt="GL Tracker">
  </div>

</div>
